import { Translation } from 'primeng/api';

/**
 * Traducoes para os componentes nativos do PrimeNG (p-calendar, p-table filtros,
 * p-fileUpload, p-confirmDialog, etc.).
 *
 * O ngx-translate nao cobre os textos internos do PrimeNG. Eles sao configurados
 * via PrimeNGConfig.setTranslation(). Este arquivo centraliza as strings por idioma
 * e e consumido pelo LanguageService ao iniciar o app e em onLangChange.
 */

export const PT_BR_PRIMENG: Translation = {
  // Calendario
  today: 'Hoje',
  clear: 'Limpar',
  dayNames: [
    'Domingo',
    'Segunda-feira',
    'Terça-feira',
    'Quarta-feira',
    'Quinta-feira',
    'Sexta-feira',
    'Sábado',
  ],
  dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sá'],
  monthNames: [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],
  monthNamesShort: [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez',
  ],
  dateFormat: 'dd/mm/yy',
  weekHeader: 'Sem',
  firstDayOfWeek: 0,
  chooseDate: 'Escolher data',
  chooseMonth: 'Escolher mês',
  chooseYear: 'Escolher ano',
  prevMonth: 'Mês anterior',
  nextMonth: 'Próximo mês',
  prevYear: 'Ano anterior',
  nextYear: 'Próximo ano',
  prevDecade: 'Década anterior',
  nextDecade: 'Próxima década',

  // Confirm / FileUpload / Dialog
  accept: 'Sim',
  reject: 'Não',
  choose: 'Escolher',
  upload: 'Enviar',
  cancel: 'Cancelar',

  // Mensagens gerais
  emptyMessage: 'Nenhum registro encontrado',
  emptyFilterMessage: 'Nenhum resultado encontrado',
  emptySearchMessage: 'Nenhum resultado encontrado',
  emptySelectionMessage: 'Nenhum item selecionado',
  searchMessage: 'Resultados disponíveis',
  selectionMessage: 'itens selecionados',

  // Filtros (p-table)
  startsWith: 'Começa com',
  contains: 'Contém',
  notContains: 'Não contém',
  endsWith: 'Termina com',
  equals: 'Igual',
  notEquals: 'Diferente',
  noFilter: 'Sem filtro',
  lt: 'Menor que',
  lte: 'Menor ou igual a',
  gt: 'Maior que',
  gte: 'Maior ou igual a',
  is: 'É',
  isNot: 'Não é',
  before: 'Antes',
  after: 'Depois',
  dateIs: 'Data igual a',
  dateIsNot: 'Data diferente de',
  dateBefore: 'Data antes de',
  dateAfter: 'Data depois de',
  apply: 'Aplicar',
  matchAll: 'Corresponder a todos',
  matchAny: 'Corresponder a qualquer',
  addRule: 'Adicionar regra',
  removeRule: 'Remover regra',

  // Password
  weak: 'Fraca',
  medium: 'Média',
  strong: 'Forte',
  passwordPrompt: 'Digite uma senha',

  // Hora (calendar com time)
  am: 'am',
  pm: 'pm',
};

export const ES_PRIMENG: Translation = {
  // Calendario
  today: 'Hoy',
  clear: 'Limpiar',
  dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
  dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
  dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
  monthNames: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  monthNamesShort: [
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dic',
  ],
  dateFormat: 'dd/mm/yy',
  weekHeader: 'Sem',
  firstDayOfWeek: 0,
  chooseDate: 'Elegir fecha',
  chooseMonth: 'Elegir mes',
  chooseYear: 'Elegir año',
  prevMonth: 'Mes anterior',
  nextMonth: 'Próximo mes',
  prevYear: 'Año anterior',
  nextYear: 'Próximo año',
  prevDecade: 'Década anterior',
  nextDecade: 'Próxima década',

  // Confirm / FileUpload / Dialog
  accept: 'Sí',
  reject: 'No',
  choose: 'Elegir',
  upload: 'Enviar',
  cancel: 'Cancelar',

  // Mensagens gerais
  emptyMessage: 'Ningún registro encontrado',
  emptyFilterMessage: 'Ningún resultado encontrado',
  emptySearchMessage: 'Ningún resultado encontrado',
  emptySelectionMessage: 'Ningún ítem seleccionado',
  searchMessage: 'Resultados disponibles',
  selectionMessage: 'ítems seleccionados',

  // Filtros (p-table)
  startsWith: 'Empieza con',
  contains: 'Contiene',
  notContains: 'No contiene',
  endsWith: 'Termina con',
  equals: 'Igual',
  notEquals: 'Distinto',
  noFilter: 'Sin filtro',
  lt: 'Menor que',
  lte: 'Menor o igual a',
  gt: 'Mayor que',
  gte: 'Mayor o igual a',
  is: 'Es',
  isNot: 'No es',
  before: 'Antes',
  after: 'Después',
  dateIs: 'Fecha igual a',
  dateIsNot: 'Fecha distinta de',
  dateBefore: 'Fecha antes de',
  dateAfter: 'Fecha después de',
  apply: 'Aplicar',
  matchAll: 'Coincidir con todos',
  matchAny: 'Coincidir con cualquiera',
  addRule: 'Agregar regla',
  removeRule: 'Quitar regla',

  // Password
  weak: 'Débil',
  medium: 'Media',
  strong: 'Fuerte',
  passwordPrompt: 'Ingrese una contraseña',

  // Hora (calendar com time)
  am: 'am',
  pm: 'pm',
};

/** Mapa conveniente idioma -> Translation */
export function getPrimeNgTranslation(lang: string): Translation {
  const l = (lang || '').toLowerCase();
  if (l.startsWith('es')) return ES_PRIMENG;
  return PT_BR_PRIMENG;
}
